import { render } from "./SkuMasterUploadList.vue?vue&type=template&id=15770c3c"
import script from "./SkuMasterUploadList.vue?vue&type=script&lang=js"
export * from "./SkuMasterUploadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__